module.exports = {
  apiServer: 'http://summit.rutc24.org:2000',
  titleList: {
    default: [{ 'value': '미선정:0', 'text': '미선정', 'amount': 0 }],
    elementary: [
      { 'value': 'TOP:150000', 'text': 'TOP', 'amount': 150000 }
    ],
    middle: [
      { 'value': 'TOP:200000', 'text': 'TOP', 'amount': 200000 },
      { 'value': 'SUMMIT:500000', 'text': 'SUMMIT', 'amount': 400000 }
    ],
    high: [
      { 'value': 'TOP:500000', 'text': 'TOP', 'amount': 500000 },
      { 'value': 'SUMMIT:1000000', 'text': 'SUMMIT', 'amount': 800000 }
    ],
    univ: [
      { 'value': 'TOP:1000000', 'text': 'TOP', 'amount': 1000000 },
      { 'value': 'SUMMIT:2000000', 'text': 'SUMMIT', 'amount': 1500000 }
    ],
    else: [
      { 'value': 'TOP:200000', 'text': 'TOP', 'amount': 200000 },
      { 'value': 'SUMMIT:500000', 'text': 'SUMMIT', 'amount': 400000 }
    ]
  },
  itsDetail: [
    '1.안함(No)',
    '2.학업 및 진로 상담(Academic and career counseling)',
    '3.전문인과의 연결(Introduced to experts)',
    '4.영적멘토 연결(Introduced to spritual mentors)'
  ],
  partList: [
    '',
    '초등56부',
    '중등부',
    '고등부',
    '대학부',
    'TCK부',
    '사랑부',
    '다민족부',
    '해외유학부',
    '농인부'
  ],
  trainingList: [
    { text: '1차합숙', value: '1차합숙' },
    { text: '순회팀합숙', value: '순회팀합숙' },
    { text: '70인1차', value: '70인1차' },
    { text: '미션홈', value: '미션홈' },
    { text: '전문별팀합숙', value: '전문별팀합숙' },
    { text: '전도합숙', value: '전도합숙' },
    { text: '전도전문훈련', value: '전도전문훈련' },
    { text: '초등합숙', value: '초등합숙' },
    { text: '초등조장합숙', value: '초등조장합숙' },
    { text: '중등합숙', value: '중등합숙' },
    { text: '초등신학원', value: '초등신학원' },
    { text: '청소년신학원', value: '청소년신학원' },
    { text: '대학신학원', value: '대학신학원' }
  ],
  donatePartList: [
    '개인',
    '부서',
    '교구',
    '지교회',
    '전도회',
    '기도회',
    '기업',
    '기타'
  ],
  topic1List: {
    default: '편집, 설계, 디자인의 메세지를, 나는 어떻게 적용, 실천하고 있나요?(How do I apply and practice the message of coordinate, draft, and design?)',
    '2021-1st': '나의 CVDIP 응답(Your CVDIP Answers) - 메시지 정리가 아닌 나의 것을 작성해 주세요(Not the summary of message, but yours)',
    '2021-2nd': '편집, 설계, 디자인의 메세지를, 나는 어떻게 적용, 실천하고 있나요?(How do I apply and practice the message of coordinate, draft, and design?)',
    '2022-1st': '편집, 설계, 디자인의 메세지를, 나는 어떻게 적용, 실천하고 있나요?(How do I apply and practice the message of coordinate, draft, and design?)',
    '2022-2nd': '편집, 설계, 디자인의 메세지를, 나는 어떻게 적용, 실천하고 있나요?(How do I apply and practice the message of coordinate, draft, and design?)',
    '2023-1st': '편집, 설계, 디자인의 메세지를, 나는 어떻게 적용, 실천하고 있나요?(How do I apply and practice the message of coordinate, draft, and design?)',
    '2023-2nd': '편집, 설계, 디자인의 메세지를, 나는 어떻게 적용, 실천하고 있나요?(How do I apply and practice the message of coordinate, draft, and design?)',
    '2024-1st': '편집, 설계, 디자인의 메세지를, 나는 어떻게 적용, 실천하고 있나요?(How do I apply and practice the message of coordinate, draft, and design?)'
  },
  topic2List: {
    default: '내가 장학금을 받아야 하는 이유(The reason for this scholarship)',
    '2021-1st': '내가 장학금을 받아야 하는 이유(The reason for this scholarship)',
    '2021-2nd': '내가 장학금을 받아야 하는 이유(The reason for this scholarship)',
    '2022-1st': '내가 장학금을 받아야 하는 이유(The reason for this scholarship)',
    '2022-2nd': '내가 장학금을 받아야 하는 이유(The reason for this scholarship)',
    '2023-1st': '내가 장학금을 받아야 하는 이유(The reason for this scholarship)',
    '2023-2nd': '내가 장학금을 받아야 하는 이유(The reason for this scholarship)',
    '2024-1st': '내가 장학금을 받아야 하는 이유(The reason for this scholarship)'
  }
}
